import { useEffect, useState } from "react";

/**
 * Current timestamp (ms) that refreshes every `intervalMs`,
 * so relative labels like "starts in" stay up to date.
 */
export const useNow = (intervalMs = 60 * 1000) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  return now;
};
